/* eslint-disable import/prefer-default-export */
import { configureStore } from '@reduxjs/toolkit';
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners } from '@reduxjs/toolkit/query';
import { merchantApi } from './services/merchant';
import { userManagementApi } from './services/userManagement';
import { paymentTransactionApi } from './services/paymentTransaction';
import merchantReducer from './features/merchant/merchantSlice';
import customerNOReducer from './features/merchant/custNOSlice';
import { transferSlipApi } from './services/transferSlip';
import { invoiceListApi } from './services/invoiceList';
import { evidencePayApi } from './services/evidencePay';
import { matchStatementApi } from './services/matchStatement';
import { statementOnlineApi } from './services/statementOnline';
import { eDocumentsApi } from './services/eDocuments';
import { logHistoryApi } from './services/logHistory';
import { groupBankApi } from './services/groupBank';
import { usageHistoryApi } from './services/usageHistory';
import { saveLogWht } from './services/saveLogWht';
import { csatApi } from './services/csat';
import CustomerManage from './components/CustomerManage';
import { customerManageApi } from './services/customerManage';
import { reportMatchApi } from './services/reportMatch';
import { approvedDataApi } from './services/AppovedData';
import { dashboardApi } from './services/dashboard';
import { invoiceExportApi } from './services/invoiceExport';


export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice

    [merchantApi.reducerPath]: merchantApi.reducer,
    [userManagementApi.reducerPath]: userManagementApi.reducer,
    [paymentTransactionApi.reducerPath]: paymentTransactionApi.reducer,
    [transferSlipApi.reducerPath]: transferSlipApi.reducer,
    [invoiceListApi.reducerPath]: invoiceListApi.reducer,
    [evidencePayApi.reducerPath]: evidencePayApi.reducer,
    [matchStatementApi.reducerPath]: matchStatementApi.reducer,
    [statementOnlineApi.reducerPath]: statementOnlineApi.reducer,
    [logHistoryApi.reducerPath]: logHistoryApi.reducer,
    [usageHistoryApi.reducerPath]: usageHistoryApi.reducer,
    [eDocumentsApi.reducerPath]: eDocumentsApi.reducer,
    [groupBankApi.reducerPath]: groupBankApi.reducer,
    merchant: merchantReducer,
    custNO: customerNOReducer,
    [saveLogWht.reducerPath]: saveLogWht.reducer,
    [csatApi.reducerPath]: csatApi.reducer,
    [customerManageApi.reducerPath]: customerManageApi.reducer,
    [reportMatchApi.reducerPath]: reportMatchApi.reducer,
    [approvedDataApi.reducerPath]: approvedDataApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [invoiceExportApi.reducerPath]: invoiceExportApi.reducer,
  },

  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(merchantApi.middleware)
      .concat(userManagementApi.middleware)
      .concat(paymentTransactionApi.middleware)
      .concat(transferSlipApi.middleware)
      .concat(invoiceListApi.middleware)
      .concat(evidencePayApi.middleware)
      .concat(matchStatementApi.middleware)
      .concat(statementOnlineApi.middleware)
      .concat(logHistoryApi.middleware)
      .concat(eDocumentsApi.middleware)
      .concat(groupBankApi.middleware)
      .concat(usageHistoryApi.middleware)
      .concat(saveLogWht.middleware)
      .concat(csatApi.middleware)
      .concat(customerManageApi.middleware)
      .concat(reportMatchApi.middleware)
      .concat(approvedDataApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(invoiceExportApi.middleware),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
